import { supabase } from '@/core/database/supabase';
import type { StockMovement } from '../types/stockMovements.types';

export const stockMovementsService = {
  async fetchMovements(companyId: string, type: string, dateFrom: string, dateTo: string) {
    if (!companyId) return [];

    let query = supabase
      .from('inventory_transactions')
      .select(`
        *,
        item:inventory_items!item_id(name, code, unit),
        creator:users!created_by(full_name),
        warehouse:warehouses!warehouse_id(name),
        project:projects!project_id(name)
      `)
      .eq('company_id', companyId)
      .order('created_at', { ascending: false });

    if (type && type !== 'all') {
      query = query.eq('transaction_type', type);
    }

    if (dateFrom) {
      query = query.gte('transaction_date', dateFrom);
    }
    if (dateTo) {
      query = query.lte('transaction_date', dateTo);
    }

    const { data, error } = await query;
    if (error) throw error;
    
    return (data || []) as unknown as StockMovement[];
  },
};
